import joinQueryParams from "../../url/joinQueryParams";
import { DEFAULT_IMAGE_EXTENSION, HM_AKAMAI_PREFIX } from './constants';
/**
 * This function returns the akamai url for an image.
 *
 * @param id - Id of the image as defined in hybris.
 * @param width - Width. Will be used to specify the imWidth paramater for Akamai.
 * @param height - Height. Will be used to specify the imHeight parameter for Akamai.
 * @returns - Return the akamai image url.
 */
const imageIdToAkamaiSrc = (id, width, height) => {
    const rootUrl = HM_AKAMAI_PREFIX;
    const dir1 = id.substr(0, 2);
    const dir2 = id.substr(2, 2);
    const extension = DEFAULT_IMAGE_EXTENSION;
    const imWidth = width ? `imwidth=${width}` : undefined;
    const imHeight = height ? `imheight=${height}` : undefined;
    const queryParams = joinQueryParams(imWidth, imHeight);
    return `${rootUrl}${dir1}/${dir2}/${id}${extension}${queryParams}`;
};
export default imageIdToAkamaiSrc;
//# sourceMappingURL=imageIdToAkamaiSrc.js.map